<template>
  <div class="computer">
    <header>
      <picture class="logo">
        <source srcset="@/assets/logo@2x.png" media="(min-resolution: 2dppx)" />
        <img src="@/assets/logo.png" alt="" />
      </picture>
      <picture class="logo-text">
        <source
          srcset="@/assets/logo-text@2x.png"
          media="(min-resolution: 2dppx)"
        />
        <img src="@/assets/logo-text.png" alt="" />
      </picture>
    </header>
    <main>
      <div class="logo-name">
        <picture>
          <source
            srcset="@/assets/logo-name@2x.png"
            media="(min-resolution: 2dppx)"
          />
          <img src="@/assets/logo-name.png" alt="" />
        </picture>
      </div>
      <div class="sub-text">
        <picture>
          <source
            srcset="@/assets/sub-text@2x.png"
            media="(min-resolution: 2dppx)"
          />
          <img src="@/assets/sub-text.png" alt="" />
        </picture>
      </div>
      <div class="button-group">
        <ElDropdown effect="light" placement="bottom" teleported="button-group">
          <div class="button">
            <picture class="button-img">
              <source
                srcset="@/assets/ios@2x.png"
                media="(min-resolution: 2dppx)"
              />
              <img src="@/assets/ios.png" alt="" />
            </picture>
            <div class="button-content">
              <div>Download on the</div>
              <div class="store-name">App Store</div>
            </div>
          </div>
          <template #dropdown>
            <Vue3NextQrcode :text="iosUrl" :size="130" margin="4" />
          </template>
        </ElDropdown>
        <ElDropdown effect="light" placement="bottom" teleported="button-group">
          <div class="button">
            <picture class="button-img">
              <source
                srcset="@/assets/android@2x.png"
                media="(min-resolution: 2dppx)"
              />
              <img src="@/assets/android.png" alt="" />
            </picture>
            <div class="button-content">
              <div>Download on the</div>
              <div class="store-name">Android</div>
            </div>
          </div>
          <template #dropdown>
            <Vue3NextQrcode :text="androidUrl" :size="130" margin="4" />
          </template>
        </ElDropdown>
      </div>
    </main>
    <footer>
      <span>无锡风睐科技有限公司</span>
      <a href="https://beian.miit.gov.cn/" target="_blank">备案号：xxxxxxx</a>
    </footer>
  </div>
</template>

<script setup>
import { ElDropdown } from "element-plus";
import { iosUrl, androidUrl } from "../../public/urlConfig";
import { Vue3NextQrcode } from "vue3-next-qrcode";
import "vue3-next-qrcode/es/style.css";
</script>
<style scoped lang="scss">
.computer {
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-rows: max-content 1fr 72px;
  header {
    display: flex;
    align-items: center;
    margin: 39px 49px 66px;
    .logo {
      & > img {
        width: 60px;
        height: 60px;
      }
    }
    .logo-text {
      margin-left: 11px;
      & > img {
        width: 117px;
        height: 33px;
      }
    }
  }
  main {
    display: flex;
    align-items: center;
    flex-direction: column;
    .logo-name {
      & img {
        width: 169px;
        height: 118px;
      }
      margin-bottom: 26px;
    }
    .sub-text {
      & img {
        width: 324px;
        height: 33px;
      }
      margin-bottom: 51px;
    }
    .button-group {
      & > div:first-child {
        margin-right: 108px;
      }
      .button {
        &:focus-visible {
          outline: none;
        }
        display: inline-grid;
        grid-template-columns: 32px 1fr;
        column-gap: 11px;
        width: 173px;
        height: 67px;
        background: #ff8dae;
        border-radius: 10px 10px 10px 10px;
        border: 2px solid #ffffff;
        align-content: center;
        padding-left: 13px;
        box-sizing: border-box;
        color: white;
        font-size: 12px;
        .button-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .button-img {
          & > img {
            width: 32px;
            height: 38px;
          }
        }
        .store-name {
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
  }
  footer {
    display: flex;
    align-items: center;
    border-top: 1px solid #ffb2cb;
    font-size: 16px;
    justify-content: center;
    & > a {
      color: #f35d8d;
      text-decoration: none;
    }
    & > span:first-child {
      margin-right: 61px;
    }
  }
}
</style>
<style>
.el-dropdown__popper .el-dropdown__list {
  padding: 10px 10px 6px !important;
}
.r-qrcode {
  border: none;
  border-radius: 0;
}
</style>
